import { useTranslation } from 'react-i18next'

export function PageErrorFallback() {
  const { t } = useTranslation()
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 p-8 text-center dark:bg-gray-900">
      <div className="mb-6 rounded-full bg-gradient-to-r from-primary-500/10 to-secondary-500/10 p-6">
        <svg
          className="h-16 w-16 text-secondary-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={1.5}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
          />
        </svg>
      </div>
      <h1 className="mb-3 text-2xl font-bold text-gray-900 dark:text-gray-100">
        {t('common.oopsSomethingWentWrong', 'Oops! Something went wrong')}
      </h1>
      <p className="mb-8 max-w-md text-gray-500 dark:text-gray-400">
        {t('common.unexpectedErrorReload', 'We encountered an unexpected error. You can try reloading the page or head back to the dashboard.')}
      </p>
      <div className="flex gap-4">
        <a
          href="/app/dashboard"
          className="rounded-lg border border-gray-300 bg-white px-5 py-2.5 text-sm font-medium text-gray-700 shadow-sm transition hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500/50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700"
        >
          {t('common.goToDashboard', 'Go to Dashboard')}
        </a>
        <button
          onClick={() => window.location.reload()}
          className="rounded-lg bg-gradient-to-r from-primary-500 to-secondary-500 px-5 py-2.5 text-sm font-medium text-white shadow-sm transition hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-primary-500/50"
        >
          {t('common.tryAgain', 'Try Again')}
        </button>
      </div>
    </div>
  )
}
